<template>
  <div>
    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="列表" name="VirtuallyList">
        <VirtuallyList v-if="card_index==='VirtuallyList'" />
      </el-tab-pane>
      <el-tab-pane label="分摊架构图" name="MeterMapList">

      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import VirtuallyList from "./VirtuallyList";
export default {
  name: "VirtuallyMain",
  components: {VirtuallyList},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      card_index:"VirtuallyList"
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/MeterVirtually/components/virtually/VirtuallyMain.vue